import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import logo from '../assets/logo.png';

import './CSS/App.css';

function Search() {

  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const search = async () => {

    if (!query.trim()) return;

    try {

      const res = await axios.get(
        `/api/search?q=${encodeURIComponent(query)}`
      );

      setResults(res.data);

    } catch (err) {

      console.log(err);

    }

  };

  return (

    <div className="app-container">

      <header className="app-header">

        <img
          className="logo"
          src={logo}
          alt="Logo"
        />

      </header>

      <div className="search-box">

        <input
          type="text"
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && search()}
        />

        <button onClick={search}>
          Search
        </button>

      </div>

      <div className="results">

        {results.map((item) => (

          <Link
            to={item.url}
            className="result-link"
            key={item.id}
          >

            <div className="result-card">

              <h2>{item.title}</h2>

              <p className="result-url">
                {item.url}
              </p>

              <p>
                {item.description}
              </p>

            </div>

          </Link>

        ))}

      </div>

    </div>

  );

}

export default Search;
